import { ref, watch, computed, onMounted } from "@vue/composition-api";
import store from "@/store";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useReceiveMethodsList() {
  // Use toast
  const toast = useToast();

  const refReceiveMethodListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: "sort_order", label: "排序", sortable: true },
    { key: "name", stickyColumn: true, label: "付款方式名稱" },
    { key: "actions", label: "操作" },
  ];
  const perPage = ref(10);
  const totalRow = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("sort_order");
  const isSortDirDesc = ref(false);

  const receiveMethodsList = ref(null);


  const dataMeta = computed(() => {
    const localItemsCount = refReceiveMethodListTable.value
      ? refReceiveMethodListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalRow.value,
    };
  });

  const refetchData = () => {
    refReceiveMethodListTable.value.refresh();
  };

  watch(
    [currentPage, perPage, searchQuery ],
    () => {
      refetchData();
    }
  );

  const fetchReceiveMethods = (ctx, callback) => {
    store
      .dispatch("receiveMethod/fetchReceiveMethods", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
      })
      .then((response) => {
        const { receive_methods, total } = response.data;
        callback(receive_methods);
        totalRow.value = total;
        receiveMethodsList.value = receive_methods

      })
      .catch((err) => {
        console.log(err);
        toast({
          component: ToastificationContent,
          props: {
            title: "獲取付款方式清單時出錯",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  onMounted(() => {
  });

  return {
    fetchReceiveMethods,
    tableColumns,
    perPage,
    currentPage,
    totalRow,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    receiveMethodsList,
    refReceiveMethodListTable,
    ability,
    refetchData,
   
  };
}
